// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => (chunkId + ".app-entry.js");